import type { StatsSnapshot } from './gameplay-snapshot';
import { CONFIG } from '../config';
import { unitStats as stats } from './index';
import { multiplyAll } from '@game-libs/exc-libs/src/helpers/array.helpers';

export const updateCatapultStats = (state: StatsSnapshot) => {
  const catapult = state.generators.catapult;
  const upgrades = state.upgrades.catapult;

  const baseDamage = catapult.baseGeneration;

  const damageMultiplier = multiplyAll([upgrades.cats.multiplier]);

  const damagePerTick = baseDamage * catapult.owned * (damageMultiplier || 1);

  const goldGeneration = damagePerTick * CONFIG.game.goldPerDamage;

  stats.catapult = {
    damagePerTick,
    goldGeneration,
  };
};
